import { Box, Drawer, Grid, Typography } from '@mui/material';
import React, { forwardRef } from 'react'
import styles from './../../../../../assets/styles/componentStyles/chatLogsStyles/chatLogsTemplatePreview.module.scss'
import globalStyles from "./../../../../../assets/styles/global.module.scss";
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import ReplyIcon from '@mui/icons-material/Reply';
import ListIcon from '@mui/icons-material/List';
import CallIcon from '@mui/icons-material/Call';
import IconsColor from '../../../../../components/utility/iconsColor';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { replacingTemplateMarkdownText } from '../../../../../utils/constants';
import TemplateButtonPreview from '../../../../../components/dashboard/channels/global/whatsapp/templates/previews/templateButtonPreview';
import TemplatePreviewGlobal from '../../../../../components/dashboard/channels/global/whatsapp/templates/previews/templatePreviewGlobal';
import CallPermissionRequestTemplate from './callPermissionRequestTemplate';
import { WHATSAPP_TEMPLATE_TYPE } from '../../../constants';
const ChatLogsTemplatePreview = forwardRef((props: any, targetRef: any) => {
    const { actionData, key } = props;
    const [open, setOpen] = React.useState(false);
    const toggleDrawer1 = (newOpen: any) => () => {
        setOpen(newOpen);
    };

    const messageText = (type: string) => {
        let template: string = "";

        if (type?.toLowerCase() === "body") {
            template = actionData.wa_body_text ? actionData.wa_body_text : "-"
        }

        else if (type?.toLowerCase() === "header") {
            template = actionData.wa_header_text ? actionData.wa_header_text : "-"
        }

        else {
            template = actionData.wa_footer_text ? actionData.wa_footer_text : "-"
        }

        return replacingTemplateMarkdownText(template);
    }

    const getSubButtonIcon = (whatsapp_template_button_sub_type_id: number | string) => {
        let subId = Number(whatsapp_template_button_sub_type_id)
        switch (subId) {
            case 3:
                return <OpenInNewOutlinedIcon style={{ display: "flex" }} className={styles.previewSubButton} />;
            case 4:
                return <CallIcon style={{ display: "flex" }} className={styles.previewSubButton} />
            case 2:
                return <ReplyIcon style={{ display: "flex" }} className={styles.previewSubButton} />
            case 1:
                return <ReplyIcon style={{ display: "flex" }} className={styles.previewSubButton} />
            case null:
                return ""
            default:
                return <ListIcon style={{ display: "flex" }} className={styles.previewSubButton} />
        }
    }

    const getSubButtonText = (subBtnData: any) => {
        let fieldVal = subBtnData?.wa_button_field_data?.filter((field: any) => field.field_name == "Button Text")[0]

        return fieldVal?.wa_template_button_sub_type_field_value
    }

    const getSubButtonDescriptionText = (subBtnData: any) => {
        let fieldVal = subBtnData?.wa_button_field_data?.filter((field: any) => field.field_name.toLowerCase() == "button description")[0];
        
        return fieldVal?.wa_template_button_sub_type_field_value || "";
    }

    const renerHeaderMediaComponent = (type: string, url: string) => {
        const haderType = type?.toLowerCase() || "";
        switch (haderType) {
            case "image":
                return <>
                    <Grid item className={`${styles.hiddenOverflowStyle} ${globalStyles.fullwidth} ${props.isCarouselTemplate && styles.hiddenOverflowStyleCarouselTemplte}`}>
                        <img alt=";php" src={url || ""} className={`${styles.templatePreviewHeaderImage} ${props.isCarouselTemplate && styles.templatePreviewHeaderImageForCarouseltemplate}`} />
                    </Grid>
                </>;
            case "video":
                return <>
                    <Grid item className={`${styles.hiddenOverflowStyle} ${globalStyles.fullwidth}`}>
                        <video key={url} style={{ width: "100%", maxHeight: "200px" }} controls className='video-tag'>
                            <source src={url || ""} type="video/mp4" />
                        </video>
                    </Grid>
                </>;
            case "text":
                return <>
                    <Grid item className={`${styles.templatePrviewHeaderItem} ${globalStyles.fullwidth}`}>
                        <pre
                            className={styles.preTextStyle}
                            dangerouslySetInnerHTML={{ __html: messageText("header") }}
                        />
                    </Grid>
                </>;
            case "document":
                return <>
                    <Grid item>
                        <Grid container className={`${globalStyles.displayFlexStyle} ${globalStyles.flexColumn} ${globalStyles.gapOne} ${styles.documentPreviewContainer} ${globalStyles.justifyCenter} ${globalStyles.alignItemCenter}`}>
                            <Grid item>
                                <IconsColor iconName="documentFile" fillColor="#000" />
                            </Grid>
                            <Grid item>
                                <Typography className={styles.documentPreviewFileName}>{url?.split('/').pop()}</Typography>
                            </Grid>
                            <Grid item>
                                <OpenInNewIcon className={styles.openDocumentIcon} onClick={() => window.open(url, "_blank")} />
                            </Grid>
                        </Grid>
                    </Grid>
                </>;
            default:
                return <></>;
        }
    }

    const isCallPermissionRequestTemplate = () => {
        if(actionData?.whatsapp_template_type && actionData?.whatsapp_template_type?.name?.toLowerCase() == WHATSAPP_TEMPLATE_TYPE['CALL_PERMISSION_REQUEST']?.toLowerCase()){
            return true;
        } 
        return false;
    }

    return (
        <>
            <Grid item
                key={key} padding={"0px"} className={`${styles.previewSectionCardBlock} ${props.isCarouselTemplate && styles.previewSectionCardBlockForCarouselTemplate}`}>

                <Grid container direction={"column"}>
                    <TemplatePreviewGlobal
                        headerType={actionData.wa_header_type_name}
                        headerURL={actionData.wa_header_media_chronox_storage_url}
                        headerVaraibleData={actionData?.wa_header_variable_data ?? []}
                        isFooter={actionData.wa_footer_text && actionData.wa_footer_text?.trim()?.length > 0}
                        headerText={messageText("header")}
                        bodyText={messageText("body")}
                        footerText={messageText("footer")}
                    />
                    {/* {
                        actionData.wa_button_data?.length > 3 && actionData.wa_button_data?.length > 3 && actionData.wa_button_data?.slice(0, 2)?.sort((button1: any, button2: any) => button1.index - button2.index)?.map((btnData: any) => {
                            return <>
                                <Grid item padding={"10px"} className={`${styles.templatePreviewButtonItem} ${styles.templatePreviewButtonItemBorder} ${globalStyles.fullwidth}`}>
                                    <Grid container justifyContent={"center"} gap={1} alignItems={"center"} flexWrap={"nowrap"}>
                                        <Grid item>
                                            {getSubButtonIcon(btnData.wa_template_button_sub_type_id)}
                                        </Grid>
                                        <Grid item>
                                            <Grid container direction={"column"}>
                                                <Grid item>
                                                    {getSubButtonText(btnData)}
                                                </Grid>
                                                <Grid item className={styles.templatePreviewBtnDescription}>
                                                    {getSubButtonDescriptionText(btnData)}
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </>
                        })
                    } */}
                    {/* {actionData.wa_button_data?.length > 3 &&
                        <Grid item paddingBlock={"12px"} className={`${styles.templatePreviewButtonItem} ${styles.templatePreviewButtonItemBorder} ${globalStyles.fullwidth}`}
                            onClick={toggleDrawer1(true)}
                        >
                            <Grid container justifyContent={"center"} gap={1} alignItems={"center"}>
                                <Grid item>
                                    <MenuIcon style={{ display: "flex" }} />
                                </Grid>
                                <Grid item>
                                    See all options
                                </Grid>
                            </Grid>
                        </Grid>
                    } */}
                </Grid>

                {/* {
                    actionData.wa_button_data?.length > 0 && actionData.wa_button_data?.length <= 3 && actionData.wa_button_data?.map((btnData: any, ind: number) => {
                        return <Grid item key={ind} padding={"10px"} className={`${styles.templatePreviewButtonItem} ${styles.templatePreviewButtonItemBorder}`}>
                            <Grid container justifyContent={"center"} gap={1} alignItems={"center"} flexWrap={"nowrap"}>
                                <Grid item>
                                    {getSubButtonIcon(btnData.wa_template_button_sub_type_id)}
                                </Grid>
                                <Grid item>
                                    <Grid container direction={"column"}>
                                        <Grid item>
                                            {getSubButtonText(btnData)}
                                        </Grid>
                                        <Grid item className={styles.templatePreviewBtnDescription}>
                                            {getSubButtonDescriptionText(btnData)}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    })
                } */}
                <TemplateButtonPreview
                    buttons={actionData.wa_button_data}
                    targetRef={targetRef}
                    previewType={'chatlogs'}
                />
            </Grid>
            {isCallPermissionRequestTemplate() && 
                <Grid item key={key} className={styles.previewSectionCardBlock} mt={1}>
                    <CallPermissionRequestTemplate
                        targetRef={targetRef}
                    />
                </Grid>
            }
            {/* <Drawer
                open={open}
                anchor='bottom'
                ref={targetRef ? targetRef.current : ""}
                onClose={toggleDrawer1(false)}
                variant="temporary"
                ModalProps={{
                    container: targetRef ? targetRef.current : "",
                    disableEnforceFocus: true,
                    style: { position: 'absolute' },
                    keepMounted: false,
                }}
                PaperProps={{
                    container: targetRef ? targetRef.current : "",
                    style: { position: 'absolute' },
                }}
                sx={{
                    transition: open ? 'opacity 275ms cubic-bezier(0.4, 0, 0.2, 1) 0ms' : 'opacity 275ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                    position: "absolute"
                }}
                BackdropProps={{ style: { position: "absolute" } }}
                SlideProps={{
                    direction: open ? "up" : "down",
                    timeout: { enter: 0, exit: 0 },
                    style: {
                        borderRadius: "32px 32px 0px 0px",
                        border: "2px solid #FAF0F0",
                        padding: "15px",
                        transition: open ? 'all 275ms cubic-bezier(0.4, 0, 0.2, 1) 0ms' : 'all 275ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
                    }
                }}
            >
                <Grid container direction={"column"} gap={"18px"} marginBottom={"15px"}>
                    <Grid item xs={12} className={`${styles.drawerContainerBoxStyle} ${globalStyles.displayFlexStyle} ${globalStyles.alignItemCenter}`} gap={"12px"}>
                        <CloseIcon className={styles.closeDrawerIconStyle} onClick={() => setOpen(false)} />
                        <span className={styles.allOptionTextStyle}>All Options</span>
                    </Grid>
                </Grid>
                {
                    actionData.wa_button_data?.length > 0 && actionData.wa_button_data?.sort((button1: any, button2: any) => button1.index - button2.index)?.map((btnData: any) => {
                        return <Grid item padding={"10px"} className={`${styles.templatePreviewButtonItem} ${styles.templatePreviewButtonItemBorder}`}>
                            <Grid container justifyContent={"center"} gap={1} alignItems={"center"} flexWrap={"nowrap"}>
                                <Grid item>
                                    {getSubButtonIcon(btnData.wa_template_button_sub_type_id)}
                                </Grid>
                                <Grid item>
                                    <Grid container direction={"column"}>
                                        <Grid item>
                                            {getSubButtonText(btnData)}
                                        </Grid>
                                        <Grid item className={styles.templatePreviewBtnDescription}>
                                            {getSubButtonDescriptionText(btnData)}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    })
                }
            </Drawer> */}
        </>
    )
});

export default ChatLogsTemplatePreview
